import React, { Fragment } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import ItemBox from '../../components/itens/item';


function ExpoMacucoScreen() {
    return (
        <Fragment>
            <Head titulo="Transparência da Expo Macuco" />
            <Header />
            <Container>
                <Row xs={1}>
                    <Col xs={{ span: 2, offset: 11 }}>
                        <Link to='/'>
                            <Button type='button' variant='danger'>Voltar</Button>
                        </Link>
                    </Col>
                </Row>
                <br />
                <br />
                <Fragment>
                    <h2>Prestação de Contas da Expo Macuco</h2>
                    <Row xs={12} lg={2}>
                        <Col>
                            <ItemBox
                                titulo={"Expo Macuco 2025"}
                                descricao={<Fragment><p>Clique aqui e veja toda prestação de contas relacionada à Exposição Agropecuária de Macuco em 2025.</p><br /></Fragment>}
                                awesome={"faHatCowboySide"}
                                link={"../transparencia/expomacuco/2025"}
                            />
                        </Col>
                        <Col>
                            <ItemBox
                                titulo={"Expo Macuco 2024"}
                                descricao={<Fragment><p>Clique aqui e veja toda prestação de contas relacionada à Exposição Agropecuária de Macuco em 2024.</p><br /></Fragment>}
                                awesome={"faHatCowboySide"}
                                link={"../transparencia/expomacuco/2024"}
                            />
                        </Col>
                        <Col>
                            <ItemBox
                                titulo={"Contratos Expo Macuco 2023"}
                                descricao={<Fragment><p>Clique aqui e veja toda prestação de contas relacionada à Exposição Agropecuária de Macuco em 2023.</p><br /></Fragment>}
                                awesome={"faHatCowboySide"}
                                link={"../transparencia/expomacuco/2023"}
                            />
                        </Col>
                        <Col>
                            <ItemBox
                                titulo={"Expo Macuco em anos anteriores"}
                                descricao={<Fragment><p>Clique aqui e veja toda prestação de contas relacionada à Exposição Agropecuária de Macuco em anos anteriores.</p><br /></Fragment>}
                                awesome={"faHatCowboySide"}
                                link={"../transparencia/expomacuco/anteriores"}
                            />
                        </Col>
                        <br />
                    </Row>
                </Fragment>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ExpoMacucoScreen;